/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./src/assets/js/custom-collection.js ***!
  \********************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ChapterScroll = /*#__PURE__*/function () {
  function ChapterScroll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ChapterScroll);
    this.chaptersContainers = options.chaptersContainers || document.querySelectorAll('.top_plp_menus');
    this.sections = options.sections || document.querySelectorAll('.grid-anchor');
    this.activeChapter = -1;
    this.ticking = false;
    this.isUserScrollingChapters = false;
    this.userScrollTimeout = null;
    this.headerHeight = 0;
    if (this.chaptersContainers.length > 0 && this.sections.length > 0) {
      this.init();
    }
  }
  return _createClass(ChapterScroll, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.calculateHeaderHeight();
      this.setupScrollListeners();
      this.setupTouchListeners();
      this.setupClickListeners();
      this.updateActiveChapter();
      window.addEventListener('resize', function () {
        return _this.calculateHeaderHeight();
      });
    }
  }, {
    key: "calculateHeaderHeight",
    value: function calculateHeaderHeight() {
      var storeHeader = document.querySelector('store-header');
      this.headerHeight = storeHeader ? storeHeader.offsetHeight : 0;
    }
  }, {
    key: "setupScrollListeners",
    value: function setupScrollListeners() {
      var _this2 = this;
      window.addEventListener('scroll', function () {
        return _this2.handlePageScroll();
      }, {
        passive: true
      });
      this.chaptersContainers.forEach(function (container) {
        var scrollableList = container.querySelector('ul');
        if (scrollableList) {
          scrollableList.addEventListener('scroll', function () {
            return _this2.handleChapterScroll();
          }, {
            passive: true
          });
        }
      });
    }
  }, {
    key: "setupTouchListeners",
    value: function setupTouchListeners() {
      var _this3 = this;
      this.chaptersContainers.forEach(function (container) {
        var scrollableList = container.querySelector('ul');
        if (scrollableList) {
          scrollableList.addEventListener('touchstart', function () {
            _this3.isUserScrollingChapters = true;
            clearTimeout(_this3.userScrollTimeout);
          }, {
            passive: true
          });
          scrollableList.addEventListener('touchend', function () {
            _this3.userScrollTimeout = setTimeout(function () {
              _this3.isUserScrollingChapters = false;
            }, 150);
          }, {
            passive: true
          });
        }
      });
    }
  }, {
    key: "setupClickListeners",
    value: function setupClickListeners() {
      var _this4 = this;
      this.chaptersContainers.forEach(function (container) {
        var buttons = container.querySelectorAll('.scrolltobtn');
        buttons.forEach(function (button, index) {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            _this4.scrollToSection(index);
          });
        });
      });
    }
  }, {
    key: "handlePageScroll",
    value: function handlePageScroll() {
      var _this5 = this;
      if (!this.ticking) {
        window.requestAnimationFrame(function () {
          _this5.updateActiveChapter();
          _this5.updateScrolledState();
          _this5.ticking = false;
        });
        this.ticking = true;
      }
    }
  }, {
    key: "handleChapterScroll",
    value: function handleChapterScroll() {
      // Just for tracking - the key is allowing native scroll behavior
      // with overscroll-behavior-x: contain in CSS
    }
  }, {
    key: "updateScrolledState",
    value: function updateScrolledState() {
      var scrollThreshold = 600;
      this.chaptersContainers.forEach(function (container) {
        if (window.scrollY > scrollThreshold) {
          container.classList.add('scrolled');
        } else {
          container.classList.remove('scrolled');
        }
      });
    }
  }, {
    key: "updateActiveChapter",
    value: function updateActiveChapter() {
      var scrollPosition = window.scrollY + window.innerHeight / 2;
      var newActiveChapter = -1;
      this.sections.forEach(function (section, index) {
        var parentBlock = section.closest('.collection-block-wrapper');
        if (!parentBlock) return;
        var rect = parentBlock.getBoundingClientRect();
        var sectionTop = window.scrollY + rect.top;
        var sectionBottom = sectionTop + rect.height;
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          newActiveChapter = index;
        }
      });

      // Handle edge case: if we're past all sections, keep the last one active
      if (newActiveChapter === -1 && this.sections.length > 0) {
        var lastSection = this.sections[this.sections.length - 1];
        var parentBlock = lastSection.closest('.collection-block-wrapper');
        if (parentBlock) {
          var rect = parentBlock.getBoundingClientRect();
          if (rect.bottom < window.innerHeight / 2) {
            newActiveChapter = this.sections.length - 1;
          }
        }
      }

      // Handle edge case: if we're before all sections
      if (newActiveChapter === -1 && window.scrollY < 300) {
        newActiveChapter = 0;
      }
      if (this.activeChapter !== newActiveChapter && newActiveChapter !== -1) {
        this.setActiveChapter(newActiveChapter);
      }
    }
  }, {
    key: "setActiveChapter",
    value: function setActiveChapter(index) {
      var _this6 = this;
      this.activeChapter = index;
      this.chaptersContainers.forEach(function (container) {
        var buttons = container.querySelectorAll('.scrolltobtn');
        buttons.forEach(function (button, btnIndex) {
          if (btnIndex === index) {
            button.classList.add('active');
            button.setAttribute('aria-current', 'true');
          } else {
            button.classList.remove('active');
            button.setAttribute('aria-current', 'false');
          }
        });

        // Only auto-scroll the nav if user isn't manually scrolling the chapters
        if (!_this6.isUserScrollingChapters && buttons[index]) {
          _this6.scrollNavToCenter(container, buttons[index]);
        }
      });
    }
  }, {
    key: "scrollNavToCenter",
    value: function scrollNavToCenter(container, activeButton) {
      var scrollableList = container.querySelector('ul');
      if (!scrollableList) return;
      var containerRect = scrollableList.getBoundingClientRect();
      var buttonRect = activeButton.getBoundingClientRect();
      var scrollLeft = scrollableList.scrollLeft;
      var containerCenter = containerRect.width / 2;
      var buttonCenter = buttonRect.left - containerRect.left + buttonRect.width / 2;
      var targetScroll = scrollLeft + buttonCenter - containerCenter;
      scrollableList.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  }, {
    key: "scrollToSection",
    value: function scrollToSection(index) {
      if (this.sections[index]) {
        var parentBlock = this.sections[index].closest('.collection-block-wrapper');
        var targetElement = parentBlock || this.sections[index];
        var offset = this.headerHeight + 100;
        var elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        var offsetPosition = elementPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }]);
}();
document.addEventListener('DOMContentLoaded', function () {
  new ChapterScroll();
});
/******/ })()
;